import React from "react";
import OwlCarousel from "react-owl-carousel";

export default function BrandCarousel({ hasBg }) {
  const options = {
    autoplay: true,
    loop: true,
    margin: 15,
    dots: true,
    slidetransition: "linear",
    autoplayTimeout: 3500,
    autoplayHoverPause: true,
    autoplaySpeed: 3500,
    responsive: {
      0: {
        items: 2,
      },
      500: {
        items: 3,
      },
      600: {
        items: 3,
      },
      800: {
        items: 5,
      },
      1200: {
        items: 5,
      },
    },
  };

  return (
    <>
      <section
        className={`client-section ptb-100 ${hasBg ? "gray-light-bg" : ""}`}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="section-heading text-center mb-5">
                {hasBg ? (
                  <span className="text-uppercase color-secondary sub-title">
                    Đối tác hàng đầu
                  </span>
                ) : (
                  ""
                )}
                <h2>Đối tác hàng đầu</h2>
                <p className="lead">
                  Chúng tôi hợp tác chặt chẽ với các đối tác lớn trên thị trường, có uy tín, đảm bảo vận hành an toàn cho doanh nghiệp của bạn
                </p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-12">
              <OwlCarousel
                className="owl-carousel owl-theme clients-carousel dot-indicator"
                {...options}
              >
                <div className="item single-client">
                  <img
                    src="assets/img/client-2-color.png"
                    alt="client logo"
                    className="client-img pt-2"
                  />
                </div>
                <div className="item single-client">
                  <img
                    src="assets/img/vihat-logo.png"
                    alt="client logo"
                    className="client-img"
                  />
                </div>
                <div className="item single-client">
                  <img
                    src="assets/img/shopee-logo.png"
                    alt="client logo"
                    className="client-img"
                  />
                </div>
                <div className="item single-client">
                  <img
                    src="assets/img/ahamove-logo.svg"
                    alt="client logo"
                    className="client-img pt-2"
                  />
                </div>
                <div className="item single-client">
                  <img
                    src="assets/img/viettel-logo.png"
                    alt="client logo"
                    className="client-img pt-2"
                  />
                </div>
              </OwlCarousel>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
